/** Where the automated review of one submission has got to. */
export enum SubmissionReviewState {
  /** No decision yet. The page keeps asking. */
  Waiting = "waiting",
  /** Every rider on the submission was counted. */
  Counted = "counted",
  /** At least one rider on the submission was not counted. */
  Refused = "refused",
  /** We stopped following it. The decision is still coming. */
  StillPending = "still_pending",
}

/** One rider the review did not count, with the sentence written for them. */
export interface SubmissionRefusal {
  /**
   * Identifies the rider apart from their name. A minor's display name is a
   * first name and last initial, so two children in one household can share
   * one and only this tells their refusals apart.
   */
  riderId: string;
  riderDisplayName: string;
  reviewerNote?: string;
}

/** What the report page shows once a ride has been sent. */
export interface SubmissionReviewOutcome {
  state: SubmissionReviewState;
  countedRiderNames: string[];
  refusals: SubmissionRefusal[];
}
